import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|History|Credential Agreements|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.CredentialAgreement,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateLatestAgreement';
export type SPCandidateLatestAgreementLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}ContentAgreementSigned`
	| `${LocNameStart}ContentAgreementNotSigned`
	| `${LocNameStart}ButtonViewAgreement`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelActiveDate`
	| `${LocNameStart}LabelExpireDate`
	| `${LocNameStart}LabelDataProvider`;

export const spCandidateLatestAgreementLocs: LocDefs<SPCandidateLatestAgreementLocNames> = {
	SPCandidateLatestAgreementTitleTab: {
		defaultValue: 'Credential Agreement',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'OtherRequirement/Candidates.CredentialAgreements.Title.Tab',
		...sharedProperties,
	},
	SPCandidateLatestAgreementTitleSection: {
		defaultValue: 'Credential Agreements',
		description: 'Section Title',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		legacyName: 'OtherRequirement/Candidates.CredentialAgreements.Title.CredentialAgreements',
		...sharedProperties,
	},
	SPCandidateLatestAgreementContentAgreementSigned: {
		defaultValue: 'This candidate has signed the latest agreement.',
		description: 'Content for agreement signed',
		displayPath: `${pathStart}Agreement Signed`,
		displayType: 'Content',
		legacyName: 'Credential.Agreement/Candidates.CredentialAgreements.Content.AgreementSigned',
		...sharedProperties,
	},
	SPCandidateLatestAgreementContentAgreementNotSigned: {
		defaultValue: 'This candidate has not signed the latest agreement',
		description: 'Content for agreement not signed',
		displayPath: `${pathStart}Content Agreement Not Signed`,
		displayType: 'Content',
		legacyName:
			'Credential.Agreement/Candidates.CredentialAgreements.Content.AgreementNotSigned',
		...sharedProperties,
	},
	SPCandidateLatestAgreementButtonViewAgreement: {
		defaultValue: 'View Latest Agreement',
		description: 'Button to view the latest agreement',
		displayPath: `${pathStart}Button View Agreement`,
		displayType: 'Button',
		legacyName: 'Credential.Agreement/Candidates.CredentialAgreements.Button.ViewAgreement',
		...sharedProperties,
	},
	SPCandidateLatestAgreementLabelName: {
		defaultValue: 'Name',
		description: 'Label for the name of the agreement',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.CredentialAgreements.ColumnHeading.Name',
		...sharedProperties,
	},
	SPCandidateLatestAgreementLabelActiveDate: {
		defaultValue: 'Active Date',
		description: 'Label for the active date of the agreement',
		displayPath: `${pathStart}Active Date`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.CredentialAgreements.ColumnHeading.ActiveDate',
		...sharedProperties,
	},
	SPCandidateLatestAgreementLabelExpireDate: {
		defaultValue: 'Expire Date',
		description: 'Label for the expire date of the agreement',
		displayPath: `${pathStart}Expire Date`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.CredentialAgreements.ColumnHeading.ExpireDate',
		...sharedProperties,
	},
	SPCandidateLatestAgreementLabelDataProvider: {
		defaultValue: 'Data Provider',
		description: 'Label for the data provider of the agreement',
		displayPath: `${pathStart}Data Provider`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.CredentialAgreements.ColumnHeading.DataProvider',
		...sharedProperties,
	},
};

export type SPCandidateLatestAgreementLocType = LocMap<SPCandidateLatestAgreementLocNames>;
